// extracted by mini-css-extract-plugin
module.exports = {"discountBadgeContainer":"DiscountBadge_discountBadgeContainer__En0Ls"};